//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getDealList } from '@/api/mamixiaowu'
import Scroll from '@/components/scroller'
export default {
  name: 'dealList',
  components: { Scroll },
  data () {
    return {
      list: [],
      random_time: '',
      sourcetype: 1,
      dealstatus: this.$store.state.user.workerObj.auth.indexOf('3') > -1 ? 1 : 2,
      page: 1,
      rows: 15
    }
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    },
    auth () {
      return this.$store.state.user.workerObj.auth || ''
    }
  },
  mounted () {
    this.loadMoreDom = this.$el.querySelector('.load-more')
    this.listDom = this.$el.querySelector('.list-scroll')
    this.getList()
  },
  methods: {
    tab (val) {
      if (this.dealstatus !== val) {
        this.listDom.scrollTop = 0
        this.page = 1
        this.dealstatus = val
        this.getList()
      }
    },
    getList (type, done) {
      getDealList({
        accountid: this.accountid,
        sourcetype: this.sourcetype,
        dealstatus: this.dealstatus,
        page: this.page,
        rows: this.rows
      }).then(res => {
        if (res.status === 'suc') {
          if (type === 'refresh') {
            this.list = []
            this.listDom.scrollTop = 0
            this.loadMoreDom.style.display = 'flex'
          }
          let obj = res.returnValue.list
          if (obj.length === 0 && this.page === 1) {
            this.list = []
            this.loadMoreDom.innerText = '暂无数据'
            this.loadMoreDom.style.display = 'flex'
          } else {
            this.list = this.page === 1 ? obj : [...this.list, ...obj]
            if (this.list.length === res.returnValue.total) {
              this.loadMoreDom.style.display = 'none'
            } else {
              this.loadMoreDom.style.display = 'flex'
            }
          }
          done && done()
        }
      }).catch(() => {
        this.notFirstLoad = true
        done && done()
      })
    },
    goDetail (id) {
      this.$router.push({
        name: 'shenbaojieguoDeclareDetail2',
        params: { id: id }
      })
    },

    // 下拉刷新
    refresh (done) {
      this.page = 1
      this.loadMoreDom.innerText = '加载中...'
      this.getList('refresh', done)
    },
    // 上拉加载更多
    loadMore (done) {
      this.page++
      this.loadMoreDom.innerText = '加载中...'
      this.getList('more', done)
    }
  }
}
